import * as React from 'react';
import clsx from 'clsx';
var sharedStyles = {
  "root": "SVG-root_1gLEH",
  "fill-green": "SVG-fill-green_3XEHx",
  "fill-blue": "SVG-fill-blue_3XxuW",
  "fill-grey-lighter": "SVG-fill-grey-lighter_ZsArp",
  "fill-grey-light": "SVG-fill-grey-light_2xlhv",
  "fill-grey": "SVG-fill-grey_BVkZ6",
  "fill-grey-dark": "SVG-fill-grey-dark_BCV7H",
  "fill-grey-darker": "SVG-fill-grey-darker_24g8W",
  "fill-anthracite": "SVG-fill-anthracite_7Va6z",
  "fill-yellow": "SVG-fill-yellow_1DmnQ",
  "fill-yellow-dark": "SVG-fill-yellow-dark_oJJ2l",
  "fill-yellow-darker": "SVG-fill-yellow-darker_3Tu8T",
  "fill-red": "SVG-fill-red_1zjVE",
  "fill-unknown": "SVG-fill-unknown_cu2te SVG-fill-grey-dark_BCV7H",
  "fill-info": "SVG-fill-info_dJHzJ",
  "fill-success": "SVG-fill-success_2sUEP",
  "fill-warning": "SVG-fill-warning_3l7NA",
  "fill-danger": "SVG-fill-danger_3h58E",
  "fill-progress": "SVG-fill-progress_1wmR1 SVG-fill-info_dJHzJ",
  "fill-white": "SVG-fill-white_1ifIm",
  "fill-accent": "SVG-fill-accent_hrCaj",
  "fill-neutral-weak": "SVG-fill-neutral-weak_RUQEU",
  "fill-neutral-plain": "SVG-fill-neutral-plain_3jzV-",
  "fill-neutral-strong": "SVG-fill-neutral-strong_2iDzN",
  "fill-disabled": "SVG-fill-disabled_2Wv9a",
  "fill-informative": "SVG-fill-informative_2TJ7Q",
  "fill-positive": "SVG-fill-positive_A2UHl",
  "fill-notice": "SVG-fill-notice_99WSg",
  "fill-negative": "SVG-fill-negative_2JTXR"
};
import loadVector from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "Svg-root_3izI7",
  "size-2x": "Svg-size-2x_1MPub",
  "size-3x": "Svg-size-3x_gRjOt",
  "size-4x": "Svg-size-4x__u1AO",
  "size-5x": "Svg-size-5x_1f6t4"
};
class Svg extends React.PureComponent {
  static has = name => !!loadVector(name);
  render() {
    const {
      name,
      size,
      theme,
      title,
      id,
      className,
      ...extra
    } = this.props;
    const Vector = loadVector(name);
    if (!Vector) {
      if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
        console.warn('No available Svg vector with name %s', name);
      }
      return null;
    }
    const rootClasses = clsx('Svg', `Svg-${name}`, styles.root, size && styles[`size-${size}`], theme && sharedStyles[`fill-${theme}`], className);
    const extraProps = Object.assign({}, title && id ? {
      'aria-labelledby': id,
      role: 'img',
      title: /*#__PURE__*/_jsx("title", {
        id: id,
        children: title
      })
    } : {
      'aria-hidden': 'true'
    }, extra);
    Vector.displayName = 'Vector';
    return /*#__PURE__*/_jsx(Vector, {
      className: rootClasses,
      ...extraProps
    });
  }
}
export default Svg;